import { render, staticRenderFns } from "./Embedded.vue?vue&type=template&id=066d4115&"
import script from "./Embedded.vue?vue&type=script&lang=js&"
export * from "./Embedded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports